import React from "react";

const AccordionList = ({ items }) => {
  return (
    <>
      {items.map((item, index) => (
        <div
          key={index}
          tabIndex={index}
          className="border collapse collapse-arrow border-gray-200 rounded-box bg-white mb-4"
        >
          <div className="text-xl font-medium collapse-title text-btnColor">
            {item.title}
          </div>
          <div className="collapse-content">{item.content}</div>
        </div>
      ))}
    </>
  );
};

export default AccordionList;
